<!--选择城市-->
<template>
  <div class="container page-city">
    <div class="current-city">
      <div @click="chooseCurrentCity">当前定位城市: {{city | formatCity}}</div>
      <div class="refresh"
           @click="getLocation"><img src="../../assets/img/ic_city_refresh.png">刷新定位</div>
    </div>
    <div class="history-city-list">
      <div class="history-city-list-item"
           v-for="(item, index) in recentChooseCity"
           :key="index"
           @click="onRecentCityItemClick(item)">
        {{item.shortName}}
      </div>
    </div>
    <div class="container-flex">
      <van-index-bar :index-list="indexList"
                     :sticky="false">
        <div v-for="(item, index) in cityTypeList"
             :key="index">
          <van-index-anchor :index="item.index">{{item.indexTitle}}</van-index-anchor>
          <van-cell :title="subItem.shortName"
                    v-for="(subItem, subIndex) in item.subCityList"
                    :key="subIndex"
                    @click="onItemClick(subItem)" />
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
import AMap from "AMap"; // 引入高德地图
import { IndexBar, IndexAnchor, Cell } from "vant";
import city from "../../common/city";
import wxJsSdk from "../../common/location";
export default {
  name: "home-city",
  components: {
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell
  },
  props: {
    value: Boolean
  },
  watch: {},
  data() {
    return {
      showCity: true,
      city: null,
      currentCityDetail: null,
      recentChooseCity: [],
      cityTypeList: [],
      indexList: [],
      userLat: null,
      userLng: null
    };
  },
  mounted() {
    this.city = this.$route.query.city;
    this.init();
  },
  methods: {
    setCurrentCity(cityDetail) {
      this.city = cityDetail.city;
      this.currentCityDetail = cityDetail;
    },
    chooseCurrentCity() {
      let chooseCity = null;
      for (let i = 0; i < city.cityArray.length; i++) {
        let item = city.cityArray[i];
        if (item.name === this.city) {
          chooseCity = item;
          break;
        }
      }
      // console.log(chooseCity);
      if (!chooseCity) {
        chooseCity = {
          pkid: this.currentCityDetail.adcode,
          name: this.currentCityDetail.city,
          shortName: this.currentCityDetail.city,
          lng: this.userLng,
          lat: this.userLat,
          pinyin: ""
        };
      }
      this.onItemClick(chooseCity);
    },
    getLocation() {
      if (process.env.NODE_ENV === "production") {
        wxJsSdk.getLocation({
          type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: res => {
            this.userLat = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            this.userLng = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            this.searchCity();
          },
          fail: () => {
            this.$toast("定位失败");
            this.userLat = 22.257935;
            this.userLng = 113.537618;
            this.searchCity();
          },
          catch: () => {
            this.$toast("定位失败");
            this.userLat = 22.257935;
            this.userLng = 113.537618;
            this.searchCity();
          }
        });
      } else {
        this.userLat = 22.257935;
        this.userLng = 113.537618;
        this.searchCity();
      }
    },
    searchCity() {
      AMap.plugin("AMap.Geocoder", () => {
        let geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: "全国"
        });
        let lnglat = [this.userLng, this.userLat];

        geocoder.getAddress(lnglat, (status, result) => {
          if (status === "complete" && result.info === "OK") {
            // result为对应的地理位置详细信息
            // console.log(result);
            this.city = result.regeocode.addressComponent.city;
            this.currentCityDetail = result.regeocode.addressComponent;
          }
        });
      });
    },
    async init() {
      let saveRecentCity = this.$common.get(
        this.$config.localKeyLogin.recentCityArray
      );
      // console.log(saveRecentCity);
      if (!this.$common.isEmpty(saveRecentCity)) {
        this.recentChooseCity = this.recentChooseCity.concat(
          saveRecentCity.value
        );
      }

      for (let i = 65; i <= 90; i++) {
        this.indexList.push(String.fromCharCode(i));
      }
      this.indexList.forEach(item => {
        this.cityTypeList.push({
          index: item,
          indexTitle: item,
          subCityList: []
        });
      });
      city.cityArray.forEach(item => {
        if (this.$common.isEmpty(item.pinyin)) {
          return;
        }
        let index = item.pinyin[0];
        this.cityTypeList[index.charCodeAt() - 65].subCityList.push(item);
      });
      this.indexList.unshift("热");
      this.cityTypeList.unshift({
        index: "热",
        indexTitle: "热门城市",
        subCityList: [
          {
            pkid: "440100",
            name: "广州市",
            shortName: "广州",
            lng: "113.280637",
            lat: "23.125178",
            pinyin: "Guangzhou"
          },
          {
            pkid: "440400",
            name: "珠海市",
            shortName: "珠海",
            lng: "113.553986",
            lat: "22.224979",
            pinyin: "Zhuhai"
          }
        ]
      });
    },
    onItemClick(item) {
      for (let i = 0; i < this.recentChooseCity.length; i++) {
        if (this.recentChooseCity[i].pkid === item.pkid) {
          this.recentChooseCity.splice(i, 1);
          break;
        }
      }
      if (this.recentChooseCity.length > 2) {
        this.recentChooseCity.splice(2, 1);
      }
      this.recentChooseCity.unshift(item);
      this.$common.save(this.$config.localKeyLogin.recentCityArray, {
        value: this.recentChooseCity
      });
      
      this.selectSuccess(item);
    },
    onRecentCityItemClick(item) {
      for (let i = 0; i < this.recentChooseCity.length; i++) {
        if (this.recentChooseCity[i].pkid === item.pkid) {
          this.recentChooseCity.splice(i, 1);
          break;
        }
      }
      this.recentChooseCity.unshift(item);
      this.selectSuccess(item);
    },
    selectSuccess(item){
      this.$common.save('selectCity',item);
      this.$common.goBack();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/less/old/var.less";
.page-city {
  background: white;
  padding: 0 0.2rem;
  .flex-column();
  .current-city {
    line-height: 0.82rem;
    font-size: 0.3rem;
    border-bottom: #d6d6d6 1px solid;
    .flex-align-center();
    justify-content: space-between;
    .refresh {
      color: @main-color;
      font-size: 0.28rem;
      .flex-align-center();
      img {
        width: 0.34rem;
        height: 0.34rem;
        margin-right: 0.1rem;
      }
    }
  }
  .history-city-list {
    .flex();
    flex-wrap: wrap;
    .history-city-list-item {
      background: #f7f7f7;
      color: #666666;
      font-size: 0.32rem;
      flex: 0 1 30%;
      text-align: center;
      padding: 0.2rem 0;
      margin: 0.2rem 0.2rem 0 0;
    }
  }
}
</style>
